var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVector1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01796 0.021657C1.14885 0.0199156 1.27863 0.0480814 1.39894 0.104343C1.51926 0.160604 1.62745 0.243717 1.71657 0.348336L10 9.36467L18.2834 0.348336C18.6826 -0.0872355 19.3014 -0.0872355 19.7006 0.348336C20.0998 0.783908 20.0998 1.45904 19.7006 1.89462L10.6986 11.6732C10.2994 12.1088 9.68064 12.1088 9.28144 11.6732L0.2994 1.87284C-0.0998001 1.43726 -0.0998001 0.762129 0.2994 0.326557C0.499002 0.108771 0.758482 -0.00012207 0.998003 -0.00012207L1.01796 0.021657Z",
    fill: "#2B2B2B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVector1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Vector-1.413e1e0fc302b9f6e70c0332244996c6.svg";